<ng-container *ngIf="menuItem">
  <li class="sidebar-menu-item"
      [ngClass]="{ 'sidebar-menu-item--mini': !_isMenuOpen }"
  >
    <ng-template [ngTemplateOutlet]="menuItem.children?.length ? expansionTemplate : linkTemplate"
                 [ngTemplateOutletContext]="{ menuItem }"></ng-template>
  </li>
</ng-container>

<ng-template #expansionTemplate let-menuItem="menuItem">
  <mat-expansion-panel #expansionPanel
                       [hideToggle]="!_isMenuOpen"
                       [disabled]="!_isMenuOpen"
  >
    <mat-expansion-panel-header (click)="!_isMenuOpen ? isMenuOpenChange.emit(true) : null">
      <ng-template [ngTemplateOutlet]="linkTemplate"
                   [ngTemplateOutletContext]="{ menuItem }"></ng-template>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <ul class="sidebar-menu-item-list">
        <li class="sidebar-menu-item sidebar-menu-item--inner"
            *ngFor="let child of menuItem.children"
        >
          <ng-template [ngTemplateOutlet]="linkTemplate"
                       [ngTemplateOutletContext]="{ menuItem: child }"></ng-template>
        </li>
      </ul>
    </ng-template>
  </mat-expansion-panel>
</ng-template>

<ng-template #linkTemplate let-menuItem="menuItem">
  <a class="sidebar-menu-item__link"
     [attr.data-testid]="menuItem.routerLink"
     [ngClass]="{ 'sidebar-menu-item__link--expansion': menuItem.children?.length }"
     [routerLinkActive]="menuItem.routerLink ? 'sidebar-menu-item__link--active' : ''"
     [routerLink]="menuItem.routerLink | replaceBusinessUnitId: businessUnitId"
     [queryParams]="menuItem.queryParams"
  >
    <ng-container *ngIf="menuItem.icon">
      <i class="flex-center" [class]="menuItem.icon"></i>
    </ng-container>

    <ng-container *ngIf="menuItem?.svgIcon">
      <mat-icon [svgIcon]="menuItem?.svgIcon" [inline]="true"></mat-icon>
    </ng-container>

    <span>{{ menuItem.name }}</span>

    <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Requested'">
      {{ serviceRequestDynamicData?.pending }}
    </div>
    <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Not Started'">
      {{ serviceRequestDynamicData?.notStarted }}
    </div>
    <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Customer SR Queue' && _isMenuOpen">
      {{ serviceRequestQueue }}
    </div>

    <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Active'">
      {{ serviceRequestDynamicData?.active }}
    </div>
    <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Completed'">
      {{ serviceRequestDynamicData?.completed }}
    </div>
  </a>
</ng-template>
